export function InstanceEditPage() {
  return <div>Instance Edit Page </div>;
}
